module.exports = __webpack_public_path__ + "static/fonts/ProximaNova-Regular.3f0bfc39.eot";